<template>
  <section class="section">
    <div class="container-xl">
      <div class="auth">
        <div class="section__header  text-center">
          <h1 class="section__title  section__title--lg">
            {{ in18['page_create_new_profile'] }}
          </h1>
          <div class="section__text">
            {{ in18['page_create_new_profile_description'] }} 👋
          </div>
        </div>

        <form @submit.prevent="submitForm">

          <div class="form__group  form__group--md  form__group--flex">
            <div class="radio">
              <input id="user_type_b2c" v-model="user.type" class="radio__input" name="name1" type="radio" value="b2c">
              <label class="radio__label" for="user_type_b2c">
                {{ in18['attribute_user_physical_person'] }}
              </label>
            </div>

            <div class="radio">
              <input id="user_type_b2b" v-model="user.type" class="radio__input" name="name1" type="radio" value="b2b">
              <label class="radio__label" for="user_type_b2b">
                {{ in18['attribute_user_legal_person'] }}
              </label>
            </div>
          </div>

          <div class="form__group  form__group--md">
            <input id="user_name" v-model="user.name" :class="{ 'error': errors['user.name'] }" class="form-control"
                   name="user_name" type="text" @input="clearValidationError('user.name')">
            <label class="form-label" for="user_name">
              {{ in18['attribute_user_first_name'] }}
              <validation-error :errors="errors['user.name']"/>
            </label>
            <svg class="form-control-icon">
              <use href="#form-user"></use>
            </svg>
          </div>

          <div class="form__group  form__group--md">
            <input id="user_surname" v-model="user.surname" :class="{ 'error': errors['user.surname'] }"
                   class="form-control" name="user_surname" type="text" @input="clearValidationError('user.surname')">
            <label class="form-label" for="user_surname">
              {{ in18['attribute_user_surname'] }}
              <validation-error :errors="errors['user.surname']"/>
            </label>
            <svg class="form-control-icon">
              <use href="#form-user"></use>
            </svg>
          </div>

          <div class="form__group  form__group--md">
            <input id="user_email" v-model="user.email" :class="{ 'error': errors['user.email'] }" autocomplete="email"
                   class="form-control" name="user_email" type="email" @input="clearValidationError('user.email')">
            <label class="form-label" for="user_email">
              {{ in18['attribute_user_email'] }}
              <validation-error :errors="errors['user.email']"/>
            </label>
            <svg class="form-control-icon">
              <use href="#form-email"></use>
            </svg>
          </div>

          <TelFormField
              :id="'mobile_phone_number'"
              v-model="user.phone"
              :errors="phoneErrors"
              :label="in18['attribute_user_phone']"
              icon="form-phone"
              name="mobile_phone_number"
              @update:model-value="clearValidationError('user.phone.number');clearValidationError('user.phone.countryCallingCode')"/>

          <div class="form__group  form__group--md">
            <input id="user_password" v-model="user.password" :class="{ 'error': errors['user.password'] }"
                   autocomplete="new-password" class="form-control" name="user_password" type="password"
                   @input="clearValidationError('user.password')">
            <label class="form-label" for="user_password">
              {{ in18['attribute_user_password'] }}
              <validation-error :errors="errors['user.password']"/>
            </label>
            <svg class="form-control-icon">
              <use href="#form-lock"></use>
            </svg>
            <button class="form-control-showhide" data-target="#user_password" type="button">
              {{ in18['attribute_show_hide'] }}
            </button>
          </div>

          <div class="form__group  form__group--md">
            <input id="confirm_user_password" v-model="user.password_confirmation"
                   :class="{ 'error': errors['user.password_confirmation'] }" autocomplete="new-password"
                   class="form-control"
                   name="confirm_user_password" type="password"
                   @input="clearValidationError('user.password_confirmation')">
            <label class="form-label" for="confirm_user_password">
              {{ in18['attribute_user_password_confirmation'] }}
              <validation-error :errors="errors['user.password_confirmation']"/>
            </label>
            <svg class="form-control-icon">
              <use href="#form-lock"></use>
            </svg>
            <button class="form-control-showhide" data-target="#confirm_user_password" type="button">
              {{ in18['attribute_show_hide'] }}
            </button>
          </div>

          <template v-if="user.type === 'b2b'">

            <div class="form__group  form__group--md">
              <input id="company_name" v-model="company.name" :class="{ 'error': errors['company.name'] }"
                     class="form-control" name="company_name" type="text" @input="clearValidationError('company.name')">
              <label class="form-label" for="company_name">
                {{ in18['attribute_company_name'] }}
                <validation-error :errors="errors['company.name']"/>
              </label>
              <svg class="form-control-icon">
                <use href="#form-building"></use>
              </svg>
            </div>


            <div class="form__group form__group--md">
              <div class="form-control form-control--select">
                <select id="company_bank_id" v-model="company.bank_id" :disabled="inProgress" class="with-icon"
                        name="company_bank_id" @input="clearValidationError('company.bank_id')">
                  <option :value="null" disabled selected>{{ in18['attribute_company_bank_option'] }}</option>
                  <option v-for="bank in banks" :key="bank.id" :value="bank.id">
                    {{ bank.name }}
                  </option>
                </select>
                <svg class="form-control-icon">
                  <use href="#form-bank"></use>
                </svg>
                <validation-error :errors="errors['company.bank_id']"/>
              </div>
            </div>

            <div class="form__group  form__group--md">
              <input id="company_acc_num" v-model="company.acc_num" :class="{ 'error': errors['company.acc_num'] }"
                     class="form-control" name="company_acc_num" type="text"
                     @input="clearValidationError('company.acc_num')">
              <label class="form-label" for="company_acc_num">
                {{ in18['attribute_company_account_number'] }}
                <validation-error :errors="errors['company.acc_num']"/>
              </label>
              <svg class="form-control-icon">
                <use href="#form-building"></use>
              </svg>
            </div>

            <div class="form__group  form__group--md">
              <input id="company_reg_num" v-model="company.reg_num" :class="{ 'error': errors['company.reg_num'] }"
                     class="form-control" name="company_reg_num" type="text"
                     @input="clearValidationError('company.reg_num')">
              <label class="form-label" for="company_reg_num">
                {{ in18['attribute_company_reg_number'] }}
                <validation-error :errors="errors['company.reg_num']"/>
              </label>
              <svg class="form-control-icon">
                <use href="#form-building"></use>
              </svg>
            </div>

            <div class="form__group  form__group--md">
              <input id="company_vat_num" v-model="company.vat_num" :class="{ 'error': errors['company.vat_num'] }"
                     class="form-control" name="company_vat_num" type="text"
                     @input="clearValidationError('company.vat_num')">
              <label class="form-label" for="company_vat_num">
                {{ in18['attribute_company_tax_number'] }}
                <validation-error :errors="errors['company.vat_num']"/>
              </label>
              <svg class="form-control-icon">
                <use href="#form-building"></use>
              </svg>
            </div>

            <div class="form__group  form__group--md">
              <input id="company_address" v-model="company.address" :class="{ 'error': errors['company.address'] }"
                     class="form-control" name="company_address" type="text"
                     @input="clearValidationError('company.address')">
              <label class="form-label" for="company_address">
                {{ in18['attribute_company_address'] }}
                <validation-error :errors="errors['company.address']"/>
              </label>
              <svg class="form-control-icon">
                <use href="#form-location"></use>
              </svg>
            </div>

            <div class="form__group  form__group--md">
              <input id="company_city" v-model="company.city" :class="{ 'error': errors['company.city'] }"
                     class="form-control" name="company_city" type="text" @input="clearValidationError('company.city')">
              <label class="form-label" for="company_city">
                {{ in18['attribute_company_city'] }}
                <validation-error :errors="errors['company.city']"/>
              </label>
              <svg class="form-control-icon">
                <use href="#form-location"></use>
              </svg>
            </div>

            <div class="form__group  form__group--md">
              <input id="company_zip" v-model="company.zip" :class="{ 'error': errors['company.zip'] }"
                     class="form-control" name="company_zip" type="text" @input="clearValidationError('company.zip')">
              <label class="form-label" for="company_city">
                {{ in18['attribute_company_zip'] }}
                <validation-error :errors="errors['company.zip']"/>
              </label>
              <svg class="form-control-icon">
                <use href="#form-location"></use>
              </svg>
            </div>

          </template>

          <div class="form__group">
            <div class="checkbox">
              <input id="terms_subscription" v-model="terms.subscription" class="checkbox__input"
                     name="terms_subscription" type="checkbox" @input="clearValidationError('terms.subscription')">
              <label class="checkbox__label" for="terms_subscription">
                {{ in18['page_subscribe_agree_label'] }}
                <validation-error :errors="errors['terms.subscription']"/>
              </label>
            </div>
          </div>

          <div class="form__group  form__group--md">
            <div class="checkbox">
              <input id="terms_privacy" v-model="terms.privacy" class="checkbox__input" name="terms_privacy"
                     type="checkbox" @input="clearValidationError('terms.privacy')">
              <label class="checkbox__label" for="terms_privacy">
                <div v-html="terms_links"/>
                <validation-error :errors="errors['terms.privacy']"/>
              </label>
            </div>
          </div>

          <google-recaptcha-v3
              id="register_us_id"
              ref="captcha"
              v-model="terms.gRecaptchaResponse"
              :site-key="captcha_site_key"
              action="register_action"
              corner/>

          <button :disabled="inProgress" class="btn  btn--red  btn--md  btn--block" type="submit">
            {{ in18['page_create_new_profile'] }}
          </button>
        </form>

        <div class="auth__footer">
          {{ in18['page_already_have_a_profile'] }}
          <a :href="login_route" :title="in18['page_sign_in']" class="link  link--primary">
            <b>{{ in18['page_sign_in'] }}</b>
          </a>
        </div>
      </div>
    </div><!-- /.container -->
  </section><!-- /.section -->
</template>

<script>

import ValidationError from '../features/ValidationError.vue';
import TelFormField from '../components/form-field/TelFormField.vue'

export default {

  components: {
    ValidationError,
    TelFormField
  },

  props: {
    in18:             {
      type: Object
    },
    captcha_site_key: {
      type: String
    },
    terms_links:      {
      type: String
    },
    login_route:      {
      type: String
    },
    phone_code:       {
      type: String
    },
    country_id:       {
      type: String
    }
  },

  computed: {
    phoneErrors() {
      let errors = []
      if (this.errors['user.phone.number']) {
        errors = errors.concat(this.errors['user.phone.number'])
      }
      if (this.errors['user.phone.countryCallingCode']) {
        errors = errors.concat(this.errors['user.phone.countryCallingCode'])
      }
      return errors
    }
  },

  data() {
    return {
      inProgress: false,
      user:       {
        type:                  'b2c',
        country_id:            this.country_id,
        name:                  '',
        surname:               '',
        email:                 '',
        password:              '',
        password_confirmation: '',
        phone:                 {
          number:             null,
          countryCallingCode: this.phone_code
        },
      },
      company:    {
        bank_id:    null,
        country_id: this.country_id,
        name:       '',
        vat_num:    '',
        reg_num:    '',
        acc_num:    '',
        city:       '',
        zip:        '',
        address:    '',
      },
      terms:      {
        subscription:       0,
        privacy:            0,
        gRecaptchaResponse: null,
      },
      banks:      {},
      errors:     {},
    };
  },

  created() {

    axios.get('/api/banks').then((response) => {
      this.banks = response.data.banks;
    });
  },

  methods: {

    clearValidationError(fieldName) {
      if (this.errors[fieldName]) {
        this.errors[fieldName] = null;
      }
    },

    submitForm() {

      if (this.isLoading) {
        return;
      }

      this.inProgress = true;

      let data = {
        user:    this.user,
        terms:   this.terms,
        company: this.company,
        address: this.address,
      };

      axios.post('/register', data).then((response) => {

        window.toastr.success(response.data.message);
        window.location.href = response.data.path;
        this.$refs.captcha.execute();

      }).catch((error) => {

        window.toastr.error(error.response.data.message);
        this.errors = error.response.data.errors;
        this.$refs.captcha.execute();
        window.scrollToErrorMessage()

      }).finally(() => {
        this.inProgress = false
      });
    }
  },
};
</script>
